import { Link } from 'react-router-dom'
const BtnBack = ({ page, text = 'Atrás' }) => {
  return (
    <Link className="btn btn-migrates-white mb-3" to={`${page}`}>
      <i className="fas fa-long-arrow-alt-left" /> {text}
    </Link>
  )
}
export default BtnBack
